import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ResultsSection() {
  const results = ['365 días de comidas resueltas', 'Menos delivery', 'Menos gasto mensual', 'Menos tiempo pensando qué cocinar', 'Más uso de tu Air Fryer', 'Más variedad para toda la familia', 'Menús para toda la semana', 'Comidas listas más rápido'];
  return <section className="py-20 md:py-32 bg-white relative border-t border-sand/50" data-id="element-244">
      <div className="max-w-4xl mx-auto px-4" data-id="element-245">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-246">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cream border border-sand text-xs font-bold tracking-widest uppercase text-charcoal/70 mb-6 shadow-sm" data-id="element-247">
            LO QUE REALMENTE OBTENÉS
          </div>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal leading-tight" data-id="element-248">
            No comprás recetas.
            <br data-id="element-249" />
            <span className="italic text-ember" data-id="element-250">Comprás tranquilidad.</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream rounded-3xl p-8 md:p-12 border border-sand shadow-sm" data-id="element-251">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-252">
            {results.map((result, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-4 bg-white p-4 rounded-xl border border-sand/50 shadow-sm" data-id="element-253">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-50 flex items-center justify-center" data-id="element-254">
                  <CheckCircle2 size={18} className="text-green-600" data-id="element-255" />
                </div>
                <span className="text-charcoal/80 font-semibold text-lg" data-id="element-256">
                  {result}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}